var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDaiqueren = function SvgDaiqueren(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.251 2.917V4.92h10.558V2.917a.5.5 0 0 1 .501-.5l2.224.001c1.403 0 2.393 1.4 2.462 3.064l.004.186v4.687a.75.75 0 0 1-1.5 0V5.668c0-.97-.447-1.694-.884-1.775l-.082-.008-1.226-.002v1.72l-.017.13c-.074.36-.399.607-.75.649l-.106.006-11.89-.004-.118-.016a.848.848 0 0 1-.67-.727l-.006-.102V3.883l-1.285.002c-.434 0-.907.666-.96 1.604l-.006.179v17.08c0 .97.448 1.696.884 1.777l.082.008h8.153a.733.733 0 1 1 0 1.467H3.466c-1.403 0-2.393-1.402-2.462-3.066L1 22.748V5.668c0-1.681.94-3.142 2.311-3.244l.154-.006 2.286-.001a.5.5 0 0 1 .5.5Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.543 2.1H8.53v.583h6.013V2.1ZM14.88.598c.573 0 1.126.33 1.197.903l.007.127v1.528c0 .608-.514.978-1.082 1.025l-.122.005H8.194c-.573 0-1.126-.33-1.197-.903l-.008-.127V1.628c0-.608.515-.979 1.083-1.025l.122-.005h6.686Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.663 15.27a.782.782 0 0 1 0 1.565H6.729a.782.782 0 0 1 0-1.564h4.934Zm4-4.778a.782.782 0 0 1 0 1.564H6.729a.782.782 0 0 1 0-1.564h8.934Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#333",
    strokeWidth: 1.5,
    cx: 18,
    cy: 18.941,
    rx: 6.25,
    ry: 6.211
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.757 15.806a.75.75 0 0 1 .743.648l.007.102-.001 1.934h1.785a.75.75 0 0 1 .744.649l.006.102a.75.75 0 0 1-.648.743l-.102.007h-2.534a.75.75 0 0 1-.743-.649l-.007-.101v-2.685a.75.75 0 0 1 .75-.75Z",
    fill: "#333",
    fillRule: "nonzero"
  }))));
};

export default SvgDaiqueren;